
    import { Component, Vue } from 'vue-property-decorator';
    import { mapActions, mapMutations, mapState } from 'vuex';
    import KassaabschlussDataTable from '@/components/Kassafuehrung/KassaabschlussDataTable.vue';
    import Kassaabschlussliste from '@/components/Kassafuehrung/Kassaabschlussliste.vue';
    import KassaabschlussDialog from '@/components/Kassafuehrung/KassaabschlussDialog.vue';

    @Component({
        components: {
            KassaabschlussDialog,
            Kassaabschlussliste,
            KassaabschlussDataTable,
        },
        computed: {
            ...mapState('kassafuehrung', ['dialogs']),
        },
        methods: {
            ...mapActions('kassafuehrung', ['kassaabschluss', 'loadKassaabschluesse']),
            ...mapMutations('kassafuehrung', ['setDialogKassaabschluss']),
        },
    })
    export default class Kassafuehrung extends Vue {
        public loadKassaabschluesse!: () => void;

        public mounted(): void {
            this.loadKassaabschluesse();
        }
    }
